import { combineReducers } from 'redux';
import { reducer as session } from './session';

const reducer = combineReducers({
  session,
});

export default reducer;
